import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuCategoriesComponent } from './menu-categories.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { 
   path: '',
    children: [
      {
        path: 'default',
        component: MenuCategoriesComponent,
        data: {
          title: "Menu Categories",
          breadcrumb: "Menu Categories"
        }
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class MenuCategoriesRoutingModule { }
